import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4f92d1e2 = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _0d5b0bfc = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _7b7c5e66 = () => interopDefault(import('../pages/blogs/index.vue' /* webpackChunkName: "pages/blogs/index" */))
const _d285f01e = () => interopDefault(import('../pages/landing/car/index.vue' /* webpackChunkName: "pages/landing/car/index" */))
const _f45f044e = () => interopDefault(import('../pages/employee-benefit/index.vue' /* webpackChunkName: "pages/employee-benefit/index" */))
const _d9144d38 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _16e0b8ab = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _63061596 = () => interopDefault(import('../pages/landing/health/index.vue' /* webpackChunkName: "pages/landing/health/index" */))
const _3123f155 = () => interopDefault(import('../pages/landing/life/index.vue' /* webpackChunkName: "pages/landing/life/index" */))
const _166f758c = () => interopDefault(import('../pages/notification/index.vue' /* webpackChunkName: "pages/notification/index" */))
const _f479d5ce = () => interopDefault(import('../pages/partnership/index.vue' /* webpackChunkName: "pages/partnership/index" */))
const _05dc32ca = () => interopDefault(import('../pages/payment/index.vue' /* webpackChunkName: "pages/payment/index" */))
const _1b146476 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _e9740638 = () => interopDefault(import('../pages/promo/index.vue' /* webpackChunkName: "pages/promo/index" */))
const _e98f6038 = () => interopDefault(import('../pages/request/index.vue' /* webpackChunkName: "pages/request/index" */))
const _28cb71de = () => interopDefault(import('../pages/landing/smartphone/index.vue' /* webpackChunkName: "pages/landing/smartphone/index" */))
const _025be225 = () => interopDefault(import('../pages/testing/index.vue' /* webpackChunkName: "pages/testing/index" */))
const _6940585d = () => interopDefault(import('../pages/toc/index.vue' /* webpackChunkName: "pages/toc/index" */))
const _1b607976 = () => interopDefault(import('../pages/transactions/index.vue' /* webpackChunkName: "pages/transactions/index" */))
const _130ac88d = () => interopDefault(import('../pages/video.vue' /* webpackChunkName: "pages/video" */))
const _e350d236 = () => interopDefault(import('../pages/claim/detail/index.vue' /* webpackChunkName: "pages/claim/detail/index" */))
const _b6fcbf60 = () => interopDefault(import('../pages/edu/car/index.vue' /* webpackChunkName: "pages/edu/car/index" */))
const _32aaa611 = () => interopDefault(import('../pages/edu/hcp/index.vue' /* webpackChunkName: "pages/edu/hcp/index" */))
const _0106e714 = () => interopDefault(import('../pages/edu/health/index.vue' /* webpackChunkName: "pages/edu/health/index" */))
const _481b3654 = () => interopDefault(import('../pages/edu/life/index.vue' /* webpackChunkName: "pages/edu/life/index" */))
const _1df5af59 = () => interopDefault(import('../pages/employee-benefit/request/index.vue' /* webpackChunkName: "pages/employee-benefit/request/index" */))
const _2740bbcd = () => interopDefault(import('../pages/employee-benefit/success/index.vue' /* webpackChunkName: "pages/employee-benefit/success/index" */))
const _4bbc256b = () => interopDefault(import('../pages/payment/method/index.vue' /* webpackChunkName: "pages/payment/method/index" */))
const _13137ae2 = () => interopDefault(import('../pages/payment/success/index.vue' /* webpackChunkName: "pages/payment/success/index" */))
const _a04e9150 = () => interopDefault(import('../pages/policy/active/index.vue' /* webpackChunkName: "pages/policy/active/index" */))
const _ce6d05b6 = () => interopDefault(import('../pages/policy/add/index.vue' /* webpackChunkName: "pages/policy/add/index" */))
const _42686ee3 = () => interopDefault(import('../pages/policy/detail/index.vue' /* webpackChunkName: "pages/policy/detail/index" */))
const _195ed672 = () => interopDefault(import('../pages/promo/detail/index.vue' /* webpackChunkName: "pages/promo/detail/index" */))
const _7b9d5eb2 = () => interopDefault(import('../pages/purchase/car/index.vue' /* webpackChunkName: "pages/purchase/car/index" */))
const _505a5668 = () => interopDefault(import('../pages/purchase/hcp/index.vue' /* webpackChunkName: "pages/purchase/hcp/index" */))
const _c0d32e82 = () => interopDefault(import('../pages/purchase/health/index.vue' /* webpackChunkName: "pages/purchase/health/index" */))
const _7438bf5f = () => interopDefault(import('../pages/purchase/life/index.vue' /* webpackChunkName: "pages/purchase/life/index" */))
const _62d6a5b4 = () => interopDefault(import('../pages/purchase/motorcycle/index.vue' /* webpackChunkName: "pages/purchase/motorcycle/index" */))
const _218c1068 = () => interopDefault(import('../pages/purchase/smartphone/index.vue' /* webpackChunkName: "pages/purchase/smartphone/index" */))
const _64755c76 = () => interopDefault(import('../pages/purchase/tropical-disease/index.vue' /* webpackChunkName: "pages/purchase/tropical-disease/index" */))
const _57a752d8 = () => interopDefault(import('../pages/request/success/index.vue' /* webpackChunkName: "pages/request/success/index" */))
const _5e090132 = () => interopDefault(import('../pages/sessions/forgot.vue' /* webpackChunkName: "pages/sessions/forgot" */))
const _9c342032 = () => interopDefault(import('../pages/sessions/register.vue' /* webpackChunkName: "pages/sessions/register" */))
const _3bfc1722 = () => interopDefault(import('../pages/sessions/tutorial.vue' /* webpackChunkName: "pages/sessions/tutorial" */))
const _602e6430 = () => interopDefault(import('../pages/smartphone/service-center-address.vue' /* webpackChunkName: "pages/smartphone/service-center-address" */))
const _10af7712 = () => interopDefault(import('../pages/smartphone/service-center-list.vue' /* webpackChunkName: "pages/smartphone/service-center-list" */))
const _682c71a0 = () => interopDefault(import('../pages/transactions/detail/index.vue' /* webpackChunkName: "pages/transactions/detail/index" */))
const _c4c9a69e = () => interopDefault(import('../pages/purchase/car/addons/index.vue' /* webpackChunkName: "pages/purchase/car/addons/index" */))
const _7625514f = () => interopDefault(import('../pages/purchase/car/detail/index.vue' /* webpackChunkName: "pages/purchase/car/detail/index" */))
const _cba15e2c = () => interopDefault(import('../pages/purchase/car/holder/index.vue' /* webpackChunkName: "pages/purchase/car/holder/index" */))
const _0da192f2 = () => interopDefault(import('../pages/purchase/car/product/index.vue' /* webpackChunkName: "pages/purchase/car/product/index" */))
const _4ed178b8 = () => interopDefault(import('../pages/purchase/car/quotation/index.vue' /* webpackChunkName: "pages/purchase/car/quotation/index" */))
const _f2c94f04 = () => interopDefault(import('../pages/purchase/car/summary/index.vue' /* webpackChunkName: "pages/purchase/car/summary/index" */))
const _32898009 = () => interopDefault(import('../pages/purchase/hcp/holder/index.vue' /* webpackChunkName: "pages/purchase/hcp/holder/index" */))
const _6c1aeb48 = () => interopDefault(import('../pages/purchase/hcp/product/index.vue' /* webpackChunkName: "pages/purchase/hcp/product/index" */))
const _0cf1e582 = () => interopDefault(import('../pages/purchase/hcp/summary/index.vue' /* webpackChunkName: "pages/purchase/hcp/summary/index" */))
const _69e0baea = () => interopDefault(import('../pages/purchase/health/declaration/index.vue' /* webpackChunkName: "pages/purchase/health/declaration/index" */))
const _603d94ec = () => interopDefault(import('../pages/purchase/health/family/index.vue' /* webpackChunkName: "pages/purchase/health/family/index" */))
const _e1dd94ac = () => interopDefault(import('../pages/purchase/health/form/index.vue' /* webpackChunkName: "pages/purchase/health/form/index" */))
const _ab09245c = () => interopDefault(import('../pages/purchase/health/holder/index.vue' /* webpackChunkName: "pages/purchase/health/holder/index" */))
const _d6cb4d80 = () => interopDefault(import('../pages/purchase/health/member/index.vue' /* webpackChunkName: "pages/purchase/health/member/index" */))
const _1b3292c2 = () => interopDefault(import('../pages/purchase/health/product/index.vue' /* webpackChunkName: "pages/purchase/health/product/index" */))
const _7fd2d896 = () => interopDefault(import('../pages/purchase/health/summary/index.vue' /* webpackChunkName: "pages/purchase/health/summary/index" */))
const _4d686332 = () => interopDefault(import('../pages/purchase/life/holder/index.vue' /* webpackChunkName: "pages/purchase/life/holder/index" */))
const _68dea0c9 = () => interopDefault(import('../pages/purchase/life/newPrequote/index.vue' /* webpackChunkName: "pages/purchase/life/newPrequote/index" */))
const _a5cf2582 = () => interopDefault(import('../pages/purchase/life/product/index.vue' /* webpackChunkName: "pages/purchase/life/product/index" */))
const _3a848f36 = () => interopDefault(import('../pages/purchase/life/summary/index.vue' /* webpackChunkName: "pages/purchase/life/summary/index" */))
const _6794b8bc = () => interopDefault(import('../pages/purchase/motorcycle/detail/index.vue' /* webpackChunkName: "pages/purchase/motorcycle/detail/index" */))
const _1f80b986 = () => interopDefault(import('../pages/purchase/motorcycle/holder/index.vue' /* webpackChunkName: "pages/purchase/motorcycle/holder/index" */))
const _65292e94 = () => interopDefault(import('../pages/purchase/motorcycle/product/index.vue' /* webpackChunkName: "pages/purchase/motorcycle/product/index" */))
const _1ad55eea = () => interopDefault(import('../pages/purchase/motorcycle/summary/index.vue' /* webpackChunkName: "pages/purchase/motorcycle/summary/index" */))
const _72d28609 = () => interopDefault(import('../pages/purchase/smartphone/holder/index.vue' /* webpackChunkName: "pages/purchase/smartphone/holder/index" */))
const _34f2a548 = () => interopDefault(import('../pages/purchase/smartphone/product/index.vue' /* webpackChunkName: "pages/purchase/smartphone/product/index" */))
const _7b427182 = () => interopDefault(import('../pages/purchase/smartphone/summary/index.vue' /* webpackChunkName: "pages/purchase/smartphone/summary/index" */))
const _4f6c2e3b = () => interopDefault(import('../pages/purchase/tropical-disease/holder/index.vue' /* webpackChunkName: "pages/purchase/tropical-disease/holder/index" */))
const _28e3f954 = () => interopDefault(import('../pages/purchase/tropical-disease/product/index.vue' /* webpackChunkName: "pages/purchase/tropical-disease/product/index" */))
const _78fa254d = () => interopDefault(import('../pages/purchase/tropical-disease/summary/index.vue' /* webpackChunkName: "pages/purchase/tropical-disease/summary/index" */))
const _1377b0dd = () => interopDefault(import('../pages/purchase/car/product/compare/index.vue' /* webpackChunkName: "pages/purchase/car/product/compare/index" */))
const _2ab30f6f = () => interopDefault(import('../pages/purchase/car/product/detail/index.vue' /* webpackChunkName: "pages/purchase/car/product/detail/index" */))
const _e092f2d0 = () => interopDefault(import('../pages/purchase/car/quotation/success/index.vue' /* webpackChunkName: "pages/purchase/car/quotation/success/index" */))
const _5107149e = () => interopDefault(import('../pages/purchase/hcp/product/compare/index.vue' /* webpackChunkName: "pages/purchase/hcp/product/compare/index" */))
const _4db7af8e = () => interopDefault(import('../pages/purchase/hcp/product/detail/index.vue' /* webpackChunkName: "pages/purchase/hcp/product/detail/index" */))
const _039998f5 = () => interopDefault(import('../pages/purchase/health/product/compare/index.vue' /* webpackChunkName: "pages/purchase/health/product/compare/index" */))
const _0927c457 = () => interopDefault(import('../pages/purchase/health/product/detail/index.vue' /* webpackChunkName: "pages/purchase/health/product/detail/index" */))
const _620aa0d6 = () => interopDefault(import('../pages/purchase/life/product/compare/index.vue' /* webpackChunkName: "pages/purchase/life/product/compare/index" */))
const _17f959b7 = () => interopDefault(import('../pages/purchase/life/product/detail/index.vue' /* webpackChunkName: "pages/purchase/life/product/detail/index" */))
const _6e815ec2 = () => interopDefault(import('../pages/purchase/motorcycle/product/detail/index.vue' /* webpackChunkName: "pages/purchase/motorcycle/product/detail/index" */))
const _60ca94e4 = () => interopDefault(import('../pages/purchase/smartphone/product/detail/index.vue' /* webpackChunkName: "pages/purchase/smartphone/product/detail/index" */))
const _33a03eac = () => interopDefault(import('../pages/purchase/tropical-disease/product/compare/index.vue' /* webpackChunkName: "pages/purchase/tropical-disease/product/compare/index" */))
const _3d2be880 = () => interopDefault(import('../pages/purchase/tropical-disease/product/detail/index.vue' /* webpackChunkName: "pages/purchase/tropical-disease/product/detail/index" */))
const _e162de42 = () => interopDefault(import('../pages/purchase/car/product/detail/_sharedId/index.vue' /* webpackChunkName: "pages/purchase/car/product/detail/_sharedId/index" */))
const _96865384 = () => interopDefault(import('../pages/purchase/hcp/product/detail/_sharedId/index.vue' /* webpackChunkName: "pages/purchase/hcp/product/detail/_sharedId/index" */))
const _ac977872 = () => interopDefault(import('../pages/purchase/health/product/detail/_sharedId/index.vue' /* webpackChunkName: "pages/purchase/health/product/detail/_sharedId/index" */))
const _1912a127 = () => interopDefault(import('../pages/purchase/life/product/detail/_sharedId/index.vue' /* webpackChunkName: "pages/purchase/life/product/detail/_sharedId/index" */))
const _7a27d71c = () => interopDefault(import('../pages/purchase/motorcycle/product/detail/_sharedId/index.vue' /* webpackChunkName: "pages/purchase/motorcycle/product/detail/_sharedId/index" */))
const _59df4784 = () => interopDefault(import('../pages/purchase/smartphone/product/detail/_sharedId/index.vue' /* webpackChunkName: "pages/purchase/smartphone/product/detail/_sharedId/index" */))
const _16d71bf0 = () => interopDefault(import('../pages/purchase/tropical-disease/product/detail/_sharedId/index.vue' /* webpackChunkName: "pages/purchase/tropical-disease/product/detail/_sharedId/index" */))
const _7dd3b144 = () => interopDefault(import('../pages/purchase/car/detail/_transactionNumber/index.vue' /* webpackChunkName: "pages/purchase/car/detail/_transactionNumber/index" */))
const _19f293e3 = () => interopDefault(import('../pages/purchase/car/holder/_transactionNumber/index.vue' /* webpackChunkName: "pages/purchase/car/holder/_transactionNumber/index" */))
const _3697a97a = () => interopDefault(import('../pages/purchase/health/family/_transactionNumber/index.vue' /* webpackChunkName: "pages/purchase/health/family/_transactionNumber/index" */))
const _4c433dfb = () => interopDefault(import('../pages/purchase/health/holder/_transactionNumber/index.vue' /* webpackChunkName: "pages/purchase/health/holder/_transactionNumber/index" */))
const _0129162b = () => interopDefault(import('../pages/purchase/motorcycle/detail/_transactionNumber/index.vue' /* webpackChunkName: "pages/purchase/motorcycle/detail/_transactionNumber/index" */))
const _5a0582b0 = () => interopDefault(import('../pages/purchase/motorcycle/holder/_transactionNumber/index.vue' /* webpackChunkName: "pages/purchase/motorcycle/holder/_transactionNumber/index" */))
const _635fdb09 = () => interopDefault(import('../pages/policy/add/_partner/index.vue' /* webpackChunkName: "pages/policy/add/_partner/index" */))
const _4bdc63f0 = () => interopDefault(import('../pages/promo/detail/_promoCode/index.vue' /* webpackChunkName: "pages/promo/detail/_promoCode/index" */))
const _dae915be = () => interopDefault(import('../pages/blogs/_slug/index.vue' /* webpackChunkName: "pages/blogs/_slug/index" */))
const _91578578 = () => interopDefault(import('../pages/claim/_product/index.vue' /* webpackChunkName: "pages/claim/_product/index" */))
const _1d485488 = () => interopDefault(import('../pages/payment/_result/index.vue' /* webpackChunkName: "pages/payment/_result/index" */))
const _3d84da91 = () => interopDefault(import('../pages/request/_product/index.vue' /* webpackChunkName: "pages/request/_product/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _4f92d1e2,
    name: "about___id"
  }, {
    path: "/account",
    component: _0d5b0bfc,
    name: "account___id"
  }, {
    path: "/blogs",
    component: _7b7c5e66,
    name: "blogs___id"
  }, {
    path: "/car",
    component: _d285f01e,
    name: "landing-car___id"
  }, {
    path: "/employee-benefit",
    component: _f45f044e,
    name: "employee-benefit___id"
  }, {
    path: "/en",
    component: _d9144d38,
    name: "index___en"
  }, {
    path: "/faq",
    component: _16e0b8ab,
    name: "faq___id"
  }, {
    path: "/health",
    component: _63061596,
    name: "landing-health___id"
  }, {
    path: "/life",
    component: _3123f155,
    name: "landing-life___id"
  }, {
    path: "/ms",
    component: _d9144d38,
    name: "index___ms"
  }, {
    path: "/notification",
    component: _166f758c,
    name: "notification___id"
  }, {
    path: "/partnership",
    component: _f479d5ce,
    name: "partnership___id"
  }, {
    path: "/payment",
    component: _05dc32ca,
    name: "payment___id"
  }, {
    path: "/products",
    component: _1b146476,
    name: "products___id"
  }, {
    path: "/promo",
    component: _e9740638,
    name: "promo___id"
  }, {
    path: "/request",
    component: _e98f6038,
    name: "request___id"
  }, {
    path: "/smartphone",
    component: _28cb71de,
    name: "landing-smartphone___id"
  }, {
    path: "/testing",
    component: _025be225,
    name: "testing___id"
  }, {
    path: "/th",
    component: _d9144d38,
    name: "index___th"
  }, {
    path: "/toc",
    component: _6940585d,
    name: "toc___id"
  }, {
    path: "/transactions",
    component: _1b607976,
    name: "transactions___id"
  }, {
    path: "/vi",
    component: _d9144d38,
    name: "index___vi"
  }, {
    path: "/video",
    component: _130ac88d,
    name: "video___id"
  }, {
    path: "/claim/detail",
    component: _e350d236,
    name: "claim-detail___id"
  }, {
    path: "/edu/car",
    component: _b6fcbf60,
    name: "edu-car___id"
  }, {
    path: "/edu/hcp",
    component: _32aaa611,
    name: "edu-hcp___id"
  }, {
    path: "/edu/health",
    component: _0106e714,
    name: "edu-health___id"
  }, {
    path: "/edu/life",
    component: _481b3654,
    name: "edu-life___id"
  }, {
    path: "/employee-benefit/request",
    component: _1df5af59,
    name: "employee-benefit-request___id"
  }, {
    path: "/employee-benefit/success",
    component: _2740bbcd,
    name: "employee-benefit-success___id"
  }, {
    path: "/en/about",
    component: _4f92d1e2,
    name: "about___en"
  }, {
    path: "/en/account",
    component: _0d5b0bfc,
    name: "account___en"
  }, {
    path: "/en/blogs",
    component: _7b7c5e66,
    name: "blogs___en"
  }, {
    path: "/en/car",
    component: _d285f01e,
    name: "landing-car___en"
  }, {
    path: "/en/employee-benefit",
    component: _f45f044e,
    name: "employee-benefit___en"
  }, {
    path: "/en/faq",
    component: _16e0b8ab,
    name: "faq___en"
  }, {
    path: "/en/health",
    component: _63061596,
    name: "landing-health___en"
  }, {
    path: "/en/life",
    component: _3123f155,
    name: "landing-life___en"
  }, {
    path: "/en/notification",
    component: _166f758c,
    name: "notification___en"
  }, {
    path: "/en/partnership",
    component: _f479d5ce,
    name: "partnership___en"
  }, {
    path: "/en/payment",
    component: _05dc32ca,
    name: "payment___en"
  }, {
    path: "/en/products",
    component: _1b146476,
    name: "products___en"
  }, {
    path: "/en/promo",
    component: _e9740638,
    name: "promo___en"
  }, {
    path: "/en/request",
    component: _e98f6038,
    name: "request___en"
  }, {
    path: "/en/smartphone",
    component: _28cb71de,
    name: "landing-smartphone___en"
  }, {
    path: "/en/testing",
    component: _025be225,
    name: "testing___en"
  }, {
    path: "/en/toc",
    component: _6940585d,
    name: "toc___en"
  }, {
    path: "/en/transactions",
    component: _1b607976,
    name: "transactions___en"
  }, {
    path: "/en/video",
    component: _130ac88d,
    name: "video___en"
  }, {
    path: "/ms/about",
    component: _4f92d1e2,
    name: "about___ms"
  }, {
    path: "/ms/account",
    component: _0d5b0bfc,
    name: "account___ms"
  }, {
    path: "/ms/blogs",
    component: _7b7c5e66,
    name: "blogs___ms"
  }, {
    path: "/ms/car",
    component: _d285f01e,
    name: "landing-car___ms"
  }, {
    path: "/ms/employee-benefit",
    component: _f45f044e,
    name: "employee-benefit___ms"
  }, {
    path: "/ms/faq",
    component: _16e0b8ab,
    name: "faq___ms"
  }, {
    path: "/ms/health",
    component: _63061596,
    name: "landing-health___ms"
  }, {
    path: "/ms/life",
    component: _3123f155,
    name: "landing-life___ms"
  }, {
    path: "/ms/notification",
    component: _166f758c,
    name: "notification___ms"
  }, {
    path: "/ms/partnership",
    component: _f479d5ce,
    name: "partnership___ms"
  }, {
    path: "/ms/payment",
    component: _05dc32ca,
    name: "payment___ms"
  }, {
    path: "/ms/products",
    component: _1b146476,
    name: "products___ms"
  }, {
    path: "/ms/promo",
    component: _e9740638,
    name: "promo___ms"
  }, {
    path: "/ms/request",
    component: _e98f6038,
    name: "request___ms"
  }, {
    path: "/ms/smartphone",
    component: _28cb71de,
    name: "landing-smartphone___ms"
  }, {
    path: "/ms/testing",
    component: _025be225,
    name: "testing___ms"
  }, {
    path: "/ms/toc",
    component: _6940585d,
    name: "toc___ms"
  }, {
    path: "/ms/transactions",
    component: _1b607976,
    name: "transactions___ms"
  }, {
    path: "/ms/video",
    component: _130ac88d,
    name: "video___ms"
  }, {
    path: "/payment/method",
    component: _4bbc256b,
    name: "payment-method___id"
  }, {
    path: "/payment/success",
    component: _13137ae2,
    name: "payment-success___id"
  }, {
    path: "/policy/active",
    component: _a04e9150,
    name: "policy-active___id"
  }, {
    path: "/policy/add",
    component: _ce6d05b6,
    name: "policy-add___id"
  }, {
    path: "/policy/detail",
    component: _42686ee3,
    name: "policy-detail___id"
  }, {
    path: "/promo/detail",
    component: _195ed672,
    name: "promo-detail___id"
  }, {
    path: "/purchase/car",
    component: _7b9d5eb2,
    name: "purchase-car___id"
  }, {
    path: "/purchase/hcp",
    component: _505a5668,
    name: "purchase-hcp___id"
  }, {
    path: "/purchase/health",
    component: _c0d32e82,
    name: "purchase-health___id"
  }, {
    path: "/purchase/life",
    component: _7438bf5f,
    name: "purchase-life___id"
  }, {
    path: "/purchase/motorcycle",
    component: _62d6a5b4,
    name: "purchase-motorcycle___id"
  }, {
    path: "/purchase/smartphone",
    component: _218c1068,
    name: "purchase-smartphone___id"
  }, {
    path: "/purchase/tropical-disease",
    component: _64755c76,
    name: "purchase-tropical-disease___id"
  }, {
    path: "/request/success",
    component: _57a752d8,
    name: "request-success___id"
  }, {
    path: "/sessions/forgot",
    component: _5e090132,
    name: "sessions-forgot___id"
  }, {
    path: "/sessions/register",
    component: _9c342032,
    name: "sessions-register___id"
  }, {
    path: "/sessions/tutorial",
    component: _3bfc1722,
    name: "sessions-tutorial___id"
  }, {
    path: "/smartphone/service-center-address",
    component: _602e6430,
    name: "smartphone-service-center-address___id"
  }, {
    path: "/smartphone/service-center-list",
    component: _10af7712,
    name: "smartphone-service-center-list___id"
  }, {
    path: "/th/about",
    component: _4f92d1e2,
    name: "about___th"
  }, {
    path: "/th/account",
    component: _0d5b0bfc,
    name: "account___th"
  }, {
    path: "/th/blogs",
    component: _7b7c5e66,
    name: "blogs___th"
  }, {
    path: "/th/car",
    component: _d285f01e,
    name: "landing-car___th"
  }, {
    path: "/th/employee-benefit",
    component: _f45f044e,
    name: "employee-benefit___th"
  }, {
    path: "/th/faq",
    component: _16e0b8ab,
    name: "faq___th"
  }, {
    path: "/th/health",
    component: _63061596,
    name: "landing-health___th"
  }, {
    path: "/th/life",
    component: _3123f155,
    name: "landing-life___th"
  }, {
    path: "/th/notification",
    component: _166f758c,
    name: "notification___th"
  }, {
    path: "/th/partnership",
    component: _f479d5ce,
    name: "partnership___th"
  }, {
    path: "/th/payment",
    component: _05dc32ca,
    name: "payment___th"
  }, {
    path: "/th/products",
    component: _1b146476,
    name: "products___th"
  }, {
    path: "/th/promo",
    component: _e9740638,
    name: "promo___th"
  }, {
    path: "/th/request",
    component: _e98f6038,
    name: "request___th"
  }, {
    path: "/th/smartphone",
    component: _28cb71de,
    name: "landing-smartphone___th"
  }, {
    path: "/th/testing",
    component: _025be225,
    name: "testing___th"
  }, {
    path: "/th/toc",
    component: _6940585d,
    name: "toc___th"
  }, {
    path: "/th/transactions",
    component: _1b607976,
    name: "transactions___th"
  }, {
    path: "/th/video",
    component: _130ac88d,
    name: "video___th"
  }, {
    path: "/transactions/detail",
    component: _682c71a0,
    name: "transactions-detail___id"
  }, {
    path: "/vi/about",
    component: _4f92d1e2,
    name: "about___vi"
  }, {
    path: "/vi/account",
    component: _0d5b0bfc,
    name: "account___vi"
  }, {
    path: "/vi/blogs",
    component: _7b7c5e66,
    name: "blogs___vi"
  }, {
    path: "/vi/car",
    component: _d285f01e,
    name: "landing-car___vi"
  }, {
    path: "/vi/employee-benefit",
    component: _f45f044e,
    name: "employee-benefit___vi"
  }, {
    path: "/vi/faq",
    component: _16e0b8ab,
    name: "faq___vi"
  }, {
    path: "/vi/health",
    component: _63061596,
    name: "landing-health___vi"
  }, {
    path: "/vi/life",
    component: _3123f155,
    name: "landing-life___vi"
  }, {
    path: "/vi/notification",
    component: _166f758c,
    name: "notification___vi"
  }, {
    path: "/vi/partnership",
    component: _f479d5ce,
    name: "partnership___vi"
  }, {
    path: "/vi/payment",
    component: _05dc32ca,
    name: "payment___vi"
  }, {
    path: "/vi/products",
    component: _1b146476,
    name: "products___vi"
  }, {
    path: "/vi/promo",
    component: _e9740638,
    name: "promo___vi"
  }, {
    path: "/vi/request",
    component: _e98f6038,
    name: "request___vi"
  }, {
    path: "/vi/smartphone",
    component: _28cb71de,
    name: "landing-smartphone___vi"
  }, {
    path: "/vi/testing",
    component: _025be225,
    name: "testing___vi"
  }, {
    path: "/vi/toc",
    component: _6940585d,
    name: "toc___vi"
  }, {
    path: "/vi/transactions",
    component: _1b607976,
    name: "transactions___vi"
  }, {
    path: "/vi/video",
    component: _130ac88d,
    name: "video___vi"
  }, {
    path: "/en/claim/detail",
    component: _e350d236,
    name: "claim-detail___en"
  }, {
    path: "/en/edu/car",
    component: _b6fcbf60,
    name: "edu-car___en"
  }, {
    path: "/en/edu/hcp",
    component: _32aaa611,
    name: "edu-hcp___en"
  }, {
    path: "/en/edu/health",
    component: _0106e714,
    name: "edu-health___en"
  }, {
    path: "/en/edu/life",
    component: _481b3654,
    name: "edu-life___en"
  }, {
    path: "/en/employee-benefit/request",
    component: _1df5af59,
    name: "employee-benefit-request___en"
  }, {
    path: "/en/employee-benefit/success",
    component: _2740bbcd,
    name: "employee-benefit-success___en"
  }, {
    path: "/en/payment/method",
    component: _4bbc256b,
    name: "payment-method___en"
  }, {
    path: "/en/payment/success",
    component: _13137ae2,
    name: "payment-success___en"
  }, {
    path: "/en/policy/active",
    component: _a04e9150,
    name: "policy-active___en"
  }, {
    path: "/en/policy/add",
    component: _ce6d05b6,
    name: "policy-add___en"
  }, {
    path: "/en/policy/detail",
    component: _42686ee3,
    name: "policy-detail___en"
  }, {
    path: "/en/promo/detail",
    component: _195ed672,
    name: "promo-detail___en"
  }, {
    path: "/en/purchase/car",
    component: _7b9d5eb2,
    name: "purchase-car___en"
  }, {
    path: "/en/purchase/hcp",
    component: _505a5668,
    name: "purchase-hcp___en"
  }, {
    path: "/en/purchase/health",
    component: _c0d32e82,
    name: "purchase-health___en"
  }, {
    path: "/en/purchase/life",
    component: _7438bf5f,
    name: "purchase-life___en"
  }, {
    path: "/en/purchase/motorcycle",
    component: _62d6a5b4,
    name: "purchase-motorcycle___en"
  }, {
    path: "/en/purchase/smartphone",
    component: _218c1068,
    name: "purchase-smartphone___en"
  }, {
    path: "/en/purchase/tropical-disease",
    component: _64755c76,
    name: "purchase-tropical-disease___en"
  }, {
    path: "/en/request/success",
    component: _57a752d8,
    name: "request-success___en"
  }, {
    path: "/en/sessions/forgot",
    component: _5e090132,
    name: "sessions-forgot___en"
  }, {
    path: "/en/sessions/register",
    component: _9c342032,
    name: "sessions-register___en"
  }, {
    path: "/en/sessions/tutorial",
    component: _3bfc1722,
    name: "sessions-tutorial___en"
  }, {
    path: "/en/smartphone/service-center-address",
    component: _602e6430,
    name: "smartphone-service-center-address___en"
  }, {
    path: "/en/smartphone/service-center-list",
    component: _10af7712,
    name: "smartphone-service-center-list___en"
  }, {
    path: "/en/transactions/detail",
    component: _682c71a0,
    name: "transactions-detail___en"
  }, {
    path: "/ms/claim/detail",
    component: _e350d236,
    name: "claim-detail___ms"
  }, {
    path: "/ms/edu/car",
    component: _b6fcbf60,
    name: "edu-car___ms"
  }, {
    path: "/ms/edu/hcp",
    component: _32aaa611,
    name: "edu-hcp___ms"
  }, {
    path: "/ms/edu/health",
    component: _0106e714,
    name: "edu-health___ms"
  }, {
    path: "/ms/edu/life",
    component: _481b3654,
    name: "edu-life___ms"
  }, {
    path: "/ms/employee-benefit/request",
    component: _1df5af59,
    name: "employee-benefit-request___ms"
  }, {
    path: "/ms/employee-benefit/success",
    component: _2740bbcd,
    name: "employee-benefit-success___ms"
  }, {
    path: "/ms/payment/method",
    component: _4bbc256b,
    name: "payment-method___ms"
  }, {
    path: "/ms/payment/success",
    component: _13137ae2,
    name: "payment-success___ms"
  }, {
    path: "/ms/policy/active",
    component: _a04e9150,
    name: "policy-active___ms"
  }, {
    path: "/ms/policy/add",
    component: _ce6d05b6,
    name: "policy-add___ms"
  }, {
    path: "/ms/policy/detail",
    component: _42686ee3,
    name: "policy-detail___ms"
  }, {
    path: "/ms/promo/detail",
    component: _195ed672,
    name: "promo-detail___ms"
  }, {
    path: "/ms/purchase/car",
    component: _7b9d5eb2,
    name: "purchase-car___ms"
  }, {
    path: "/ms/purchase/hcp",
    component: _505a5668,
    name: "purchase-hcp___ms"
  }, {
    path: "/ms/purchase/health",
    component: _c0d32e82,
    name: "purchase-health___ms"
  }, {
    path: "/ms/purchase/life",
    component: _7438bf5f,
    name: "purchase-life___ms"
  }, {
    path: "/ms/purchase/motorcycle",
    component: _62d6a5b4,
    name: "purchase-motorcycle___ms"
  }, {
    path: "/ms/purchase/smartphone",
    component: _218c1068,
    name: "purchase-smartphone___ms"
  }, {
    path: "/ms/purchase/tropical-disease",
    component: _64755c76,
    name: "purchase-tropical-disease___ms"
  }, {
    path: "/ms/request/success",
    component: _57a752d8,
    name: "request-success___ms"
  }, {
    path: "/ms/sessions/forgot",
    component: _5e090132,
    name: "sessions-forgot___ms"
  }, {
    path: "/ms/sessions/register",
    component: _9c342032,
    name: "sessions-register___ms"
  }, {
    path: "/ms/sessions/tutorial",
    component: _3bfc1722,
    name: "sessions-tutorial___ms"
  }, {
    path: "/ms/smartphone/service-center-address",
    component: _602e6430,
    name: "smartphone-service-center-address___ms"
  }, {
    path: "/ms/smartphone/service-center-list",
    component: _10af7712,
    name: "smartphone-service-center-list___ms"
  }, {
    path: "/ms/transactions/detail",
    component: _682c71a0,
    name: "transactions-detail___ms"
  }, {
    path: "/purchase/car/addons",
    component: _c4c9a69e,
    name: "purchase-car-addons___id"
  }, {
    path: "/purchase/car/detail",
    component: _7625514f,
    name: "purchase-car-detail___id"
  }, {
    path: "/purchase/car/holder",
    component: _cba15e2c,
    name: "purchase-car-holder___id"
  }, {
    path: "/purchase/car/product",
    component: _0da192f2,
    name: "purchase-car-product___id"
  }, {
    path: "/purchase/car/quotation",
    component: _4ed178b8,
    name: "purchase-car-quotation___id"
  }, {
    path: "/purchase/car/summary",
    component: _f2c94f04,
    name: "purchase-car-summary___id"
  }, {
    path: "/purchase/hcp/holder",
    component: _32898009,
    name: "purchase-hcp-holder___id"
  }, {
    path: "/purchase/hcp/product",
    component: _6c1aeb48,
    name: "purchase-hcp-product___id"
  }, {
    path: "/purchase/hcp/summary",
    component: _0cf1e582,
    name: "purchase-hcp-summary___id"
  }, {
    path: "/purchase/health/declaration",
    component: _69e0baea,
    name: "purchase-health-declaration___id"
  }, {
    path: "/purchase/health/family",
    component: _603d94ec,
    name: "purchase-health-family___id"
  }, {
    path: "/purchase/health/form",
    component: _e1dd94ac,
    name: "purchase-health-form___id"
  }, {
    path: "/purchase/health/holder",
    component: _ab09245c,
    name: "purchase-health-holder___id"
  }, {
    path: "/purchase/health/member",
    component: _d6cb4d80,
    name: "purchase-health-member___id"
  }, {
    path: "/purchase/health/product",
    component: _1b3292c2,
    name: "purchase-health-product___id"
  }, {
    path: "/purchase/health/summary",
    component: _7fd2d896,
    name: "purchase-health-summary___id"
  }, {
    path: "/purchase/life/holder",
    component: _4d686332,
    name: "purchase-life-holder___id"
  }, {
    path: "/purchase/life/newPrequote",
    component: _68dea0c9,
    name: "purchase-life-newPrequote___id"
  }, {
    path: "/purchase/life/product",
    component: _a5cf2582,
    name: "purchase-life-product___id"
  }, {
    path: "/purchase/life/summary",
    component: _3a848f36,
    name: "purchase-life-summary___id"
  }, {
    path: "/purchase/motorcycle/detail",
    component: _6794b8bc,
    name: "purchase-motorcycle-detail___id"
  }, {
    path: "/purchase/motorcycle/holder",
    component: _1f80b986,
    name: "purchase-motorcycle-holder___id"
  }, {
    path: "/purchase/motorcycle/product",
    component: _65292e94,
    name: "purchase-motorcycle-product___id"
  }, {
    path: "/purchase/motorcycle/summary",
    component: _1ad55eea,
    name: "purchase-motorcycle-summary___id"
  }, {
    path: "/purchase/smartphone/holder",
    component: _72d28609,
    name: "purchase-smartphone-holder___id"
  }, {
    path: "/purchase/smartphone/product",
    component: _34f2a548,
    name: "purchase-smartphone-product___id"
  }, {
    path: "/purchase/smartphone/summary",
    component: _7b427182,
    name: "purchase-smartphone-summary___id"
  }, {
    path: "/purchase/tropical-disease/holder",
    component: _4f6c2e3b,
    name: "purchase-tropical-disease-holder___id"
  }, {
    path: "/purchase/tropical-disease/product",
    component: _28e3f954,
    name: "purchase-tropical-disease-product___id"
  }, {
    path: "/purchase/tropical-disease/summary",
    component: _78fa254d,
    name: "purchase-tropical-disease-summary___id"
  }, {
    path: "/th/claim/detail",
    component: _e350d236,
    name: "claim-detail___th"
  }, {
    path: "/th/edu/car",
    component: _b6fcbf60,
    name: "edu-car___th"
  }, {
    path: "/th/edu/hcp",
    component: _32aaa611,
    name: "edu-hcp___th"
  }, {
    path: "/th/edu/health",
    component: _0106e714,
    name: "edu-health___th"
  }, {
    path: "/th/edu/life",
    component: _481b3654,
    name: "edu-life___th"
  }, {
    path: "/th/employee-benefit/request",
    component: _1df5af59,
    name: "employee-benefit-request___th"
  }, {
    path: "/th/employee-benefit/success",
    component: _2740bbcd,
    name: "employee-benefit-success___th"
  }, {
    path: "/th/payment/method",
    component: _4bbc256b,
    name: "payment-method___th"
  }, {
    path: "/th/payment/success",
    component: _13137ae2,
    name: "payment-success___th"
  }, {
    path: "/th/policy/active",
    component: _a04e9150,
    name: "policy-active___th"
  }, {
    path: "/th/policy/add",
    component: _ce6d05b6,
    name: "policy-add___th"
  }, {
    path: "/th/policy/detail",
    component: _42686ee3,
    name: "policy-detail___th"
  }, {
    path: "/th/promo/detail",
    component: _195ed672,
    name: "promo-detail___th"
  }, {
    path: "/th/purchase/car",
    component: _7b9d5eb2,
    name: "purchase-car___th"
  }, {
    path: "/th/purchase/hcp",
    component: _505a5668,
    name: "purchase-hcp___th"
  }, {
    path: "/th/purchase/health",
    component: _c0d32e82,
    name: "purchase-health___th"
  }, {
    path: "/th/purchase/life",
    component: _7438bf5f,
    name: "purchase-life___th"
  }, {
    path: "/th/purchase/motorcycle",
    component: _62d6a5b4,
    name: "purchase-motorcycle___th"
  }, {
    path: "/th/purchase/smartphone",
    component: _218c1068,
    name: "purchase-smartphone___th"
  }, {
    path: "/th/purchase/tropical-disease",
    component: _64755c76,
    name: "purchase-tropical-disease___th"
  }, {
    path: "/th/request/success",
    component: _57a752d8,
    name: "request-success___th"
  }, {
    path: "/th/sessions/forgot",
    component: _5e090132,
    name: "sessions-forgot___th"
  }, {
    path: "/th/sessions/register",
    component: _9c342032,
    name: "sessions-register___th"
  }, {
    path: "/th/sessions/tutorial",
    component: _3bfc1722,
    name: "sessions-tutorial___th"
  }, {
    path: "/th/smartphone/service-center-address",
    component: _602e6430,
    name: "smartphone-service-center-address___th"
  }, {
    path: "/th/smartphone/service-center-list",
    component: _10af7712,
    name: "smartphone-service-center-list___th"
  }, {
    path: "/th/transactions/detail",
    component: _682c71a0,
    name: "transactions-detail___th"
  }, {
    path: "/vi/claim/detail",
    component: _e350d236,
    name: "claim-detail___vi"
  }, {
    path: "/vi/edu/car",
    component: _b6fcbf60,
    name: "edu-car___vi"
  }, {
    path: "/vi/edu/hcp",
    component: _32aaa611,
    name: "edu-hcp___vi"
  }, {
    path: "/vi/edu/health",
    component: _0106e714,
    name: "edu-health___vi"
  }, {
    path: "/vi/edu/life",
    component: _481b3654,
    name: "edu-life___vi"
  }, {
    path: "/vi/employee-benefit/request",
    component: _1df5af59,
    name: "employee-benefit-request___vi"
  }, {
    path: "/vi/employee-benefit/success",
    component: _2740bbcd,
    name: "employee-benefit-success___vi"
  }, {
    path: "/vi/payment/method",
    component: _4bbc256b,
    name: "payment-method___vi"
  }, {
    path: "/vi/payment/success",
    component: _13137ae2,
    name: "payment-success___vi"
  }, {
    path: "/vi/policy/active",
    component: _a04e9150,
    name: "policy-active___vi"
  }, {
    path: "/vi/policy/add",
    component: _ce6d05b6,
    name: "policy-add___vi"
  }, {
    path: "/vi/policy/detail",
    component: _42686ee3,
    name: "policy-detail___vi"
  }, {
    path: "/vi/promo/detail",
    component: _195ed672,
    name: "promo-detail___vi"
  }, {
    path: "/vi/purchase/car",
    component: _7b9d5eb2,
    name: "purchase-car___vi"
  }, {
    path: "/vi/purchase/hcp",
    component: _505a5668,
    name: "purchase-hcp___vi"
  }, {
    path: "/vi/purchase/health",
    component: _c0d32e82,
    name: "purchase-health___vi"
  }, {
    path: "/vi/purchase/life",
    component: _7438bf5f,
    name: "purchase-life___vi"
  }, {
    path: "/vi/purchase/motorcycle",
    component: _62d6a5b4,
    name: "purchase-motorcycle___vi"
  }, {
    path: "/vi/purchase/smartphone",
    component: _218c1068,
    name: "purchase-smartphone___vi"
  }, {
    path: "/vi/purchase/tropical-disease",
    component: _64755c76,
    name: "purchase-tropical-disease___vi"
  }, {
    path: "/vi/request/success",
    component: _57a752d8,
    name: "request-success___vi"
  }, {
    path: "/vi/sessions/forgot",
    component: _5e090132,
    name: "sessions-forgot___vi"
  }, {
    path: "/vi/sessions/register",
    component: _9c342032,
    name: "sessions-register___vi"
  }, {
    path: "/vi/sessions/tutorial",
    component: _3bfc1722,
    name: "sessions-tutorial___vi"
  }, {
    path: "/vi/smartphone/service-center-address",
    component: _602e6430,
    name: "smartphone-service-center-address___vi"
  }, {
    path: "/vi/smartphone/service-center-list",
    component: _10af7712,
    name: "smartphone-service-center-list___vi"
  }, {
    path: "/vi/transactions/detail",
    component: _682c71a0,
    name: "transactions-detail___vi"
  }, {
    path: "/en/purchase/car/addons",
    component: _c4c9a69e,
    name: "purchase-car-addons___en"
  }, {
    path: "/en/purchase/car/detail",
    component: _7625514f,
    name: "purchase-car-detail___en"
  }, {
    path: "/en/purchase/car/holder",
    component: _cba15e2c,
    name: "purchase-car-holder___en"
  }, {
    path: "/en/purchase/car/product",
    component: _0da192f2,
    name: "purchase-car-product___en"
  }, {
    path: "/en/purchase/car/quotation",
    component: _4ed178b8,
    name: "purchase-car-quotation___en"
  }, {
    path: "/en/purchase/car/summary",
    component: _f2c94f04,
    name: "purchase-car-summary___en"
  }, {
    path: "/en/purchase/hcp/holder",
    component: _32898009,
    name: "purchase-hcp-holder___en"
  }, {
    path: "/en/purchase/hcp/product",
    component: _6c1aeb48,
    name: "purchase-hcp-product___en"
  }, {
    path: "/en/purchase/hcp/summary",
    component: _0cf1e582,
    name: "purchase-hcp-summary___en"
  }, {
    path: "/en/purchase/health/declaration",
    component: _69e0baea,
    name: "purchase-health-declaration___en"
  }, {
    path: "/en/purchase/health/family",
    component: _603d94ec,
    name: "purchase-health-family___en"
  }, {
    path: "/en/purchase/health/form",
    component: _e1dd94ac,
    name: "purchase-health-form___en"
  }, {
    path: "/en/purchase/health/holder",
    component: _ab09245c,
    name: "purchase-health-holder___en"
  }, {
    path: "/en/purchase/health/member",
    component: _d6cb4d80,
    name: "purchase-health-member___en"
  }, {
    path: "/en/purchase/health/product",
    component: _1b3292c2,
    name: "purchase-health-product___en"
  }, {
    path: "/en/purchase/health/summary",
    component: _7fd2d896,
    name: "purchase-health-summary___en"
  }, {
    path: "/en/purchase/life/holder",
    component: _4d686332,
    name: "purchase-life-holder___en"
  }, {
    path: "/en/purchase/life/newPrequote",
    component: _68dea0c9,
    name: "purchase-life-newPrequote___en"
  }, {
    path: "/en/purchase/life/product",
    component: _a5cf2582,
    name: "purchase-life-product___en"
  }, {
    path: "/en/purchase/life/summary",
    component: _3a848f36,
    name: "purchase-life-summary___en"
  }, {
    path: "/en/purchase/motorcycle/detail",
    component: _6794b8bc,
    name: "purchase-motorcycle-detail___en"
  }, {
    path: "/en/purchase/motorcycle/holder",
    component: _1f80b986,
    name: "purchase-motorcycle-holder___en"
  }, {
    path: "/en/purchase/motorcycle/product",
    component: _65292e94,
    name: "purchase-motorcycle-product___en"
  }, {
    path: "/en/purchase/motorcycle/summary",
    component: _1ad55eea,
    name: "purchase-motorcycle-summary___en"
  }, {
    path: "/en/purchase/smartphone/holder",
    component: _72d28609,
    name: "purchase-smartphone-holder___en"
  }, {
    path: "/en/purchase/smartphone/product",
    component: _34f2a548,
    name: "purchase-smartphone-product___en"
  }, {
    path: "/en/purchase/smartphone/summary",
    component: _7b427182,
    name: "purchase-smartphone-summary___en"
  }, {
    path: "/en/purchase/tropical-disease/holder",
    component: _4f6c2e3b,
    name: "purchase-tropical-disease-holder___en"
  }, {
    path: "/en/purchase/tropical-disease/product",
    component: _28e3f954,
    name: "purchase-tropical-disease-product___en"
  }, {
    path: "/en/purchase/tropical-disease/summary",
    component: _78fa254d,
    name: "purchase-tropical-disease-summary___en"
  }, {
    path: "/ms/purchase/car/addons",
    component: _c4c9a69e,
    name: "purchase-car-addons___ms"
  }, {
    path: "/ms/purchase/car/detail",
    component: _7625514f,
    name: "purchase-car-detail___ms"
  }, {
    path: "/ms/purchase/car/holder",
    component: _cba15e2c,
    name: "purchase-car-holder___ms"
  }, {
    path: "/ms/purchase/car/product",
    component: _0da192f2,
    name: "purchase-car-product___ms"
  }, {
    path: "/ms/purchase/car/quotation",
    component: _4ed178b8,
    name: "purchase-car-quotation___ms"
  }, {
    path: "/ms/purchase/car/summary",
    component: _f2c94f04,
    name: "purchase-car-summary___ms"
  }, {
    path: "/ms/purchase/hcp/holder",
    component: _32898009,
    name: "purchase-hcp-holder___ms"
  }, {
    path: "/ms/purchase/hcp/product",
    component: _6c1aeb48,
    name: "purchase-hcp-product___ms"
  }, {
    path: "/ms/purchase/hcp/summary",
    component: _0cf1e582,
    name: "purchase-hcp-summary___ms"
  }, {
    path: "/ms/purchase/health/declaration",
    component: _69e0baea,
    name: "purchase-health-declaration___ms"
  }, {
    path: "/ms/purchase/health/family",
    component: _603d94ec,
    name: "purchase-health-family___ms"
  }, {
    path: "/ms/purchase/health/form",
    component: _e1dd94ac,
    name: "purchase-health-form___ms"
  }, {
    path: "/ms/purchase/health/holder",
    component: _ab09245c,
    name: "purchase-health-holder___ms"
  }, {
    path: "/ms/purchase/health/member",
    component: _d6cb4d80,
    name: "purchase-health-member___ms"
  }, {
    path: "/ms/purchase/health/product",
    component: _1b3292c2,
    name: "purchase-health-product___ms"
  }, {
    path: "/ms/purchase/health/summary",
    component: _7fd2d896,
    name: "purchase-health-summary___ms"
  }, {
    path: "/ms/purchase/life/holder",
    component: _4d686332,
    name: "purchase-life-holder___ms"
  }, {
    path: "/ms/purchase/life/newPrequote",
    component: _68dea0c9,
    name: "purchase-life-newPrequote___ms"
  }, {
    path: "/ms/purchase/life/product",
    component: _a5cf2582,
    name: "purchase-life-product___ms"
  }, {
    path: "/ms/purchase/life/summary",
    component: _3a848f36,
    name: "purchase-life-summary___ms"
  }, {
    path: "/ms/purchase/motorcycle/detail",
    component: _6794b8bc,
    name: "purchase-motorcycle-detail___ms"
  }, {
    path: "/ms/purchase/motorcycle/holder",
    component: _1f80b986,
    name: "purchase-motorcycle-holder___ms"
  }, {
    path: "/ms/purchase/motorcycle/product",
    component: _65292e94,
    name: "purchase-motorcycle-product___ms"
  }, {
    path: "/ms/purchase/motorcycle/summary",
    component: _1ad55eea,
    name: "purchase-motorcycle-summary___ms"
  }, {
    path: "/ms/purchase/smartphone/holder",
    component: _72d28609,
    name: "purchase-smartphone-holder___ms"
  }, {
    path: "/ms/purchase/smartphone/product",
    component: _34f2a548,
    name: "purchase-smartphone-product___ms"
  }, {
    path: "/ms/purchase/smartphone/summary",
    component: _7b427182,
    name: "purchase-smartphone-summary___ms"
  }, {
    path: "/ms/purchase/tropical-disease/holder",
    component: _4f6c2e3b,
    name: "purchase-tropical-disease-holder___ms"
  }, {
    path: "/ms/purchase/tropical-disease/product",
    component: _28e3f954,
    name: "purchase-tropical-disease-product___ms"
  }, {
    path: "/ms/purchase/tropical-disease/summary",
    component: _78fa254d,
    name: "purchase-tropical-disease-summary___ms"
  }, {
    path: "/purchase/car/product/compare",
    component: _1377b0dd,
    name: "purchase-car-product-compare___id"
  }, {
    path: "/purchase/car/product/detail",
    component: _2ab30f6f,
    name: "purchase-car-product-detail___id"
  }, {
    path: "/purchase/car/quotation/success",
    component: _e092f2d0,
    name: "purchase-car-quotation-success___id"
  }, {
    path: "/purchase/hcp/product/compare",
    component: _5107149e,
    name: "purchase-hcp-product-compare___id"
  }, {
    path: "/purchase/hcp/product/detail",
    component: _4db7af8e,
    name: "purchase-hcp-product-detail___id"
  }, {
    path: "/purchase/health/product/compare",
    component: _039998f5,
    name: "purchase-health-product-compare___id"
  }, {
    path: "/purchase/health/product/detail",
    component: _0927c457,
    name: "purchase-health-product-detail___id"
  }, {
    path: "/purchase/life/product/compare",
    component: _620aa0d6,
    name: "purchase-life-product-compare___id"
  }, {
    path: "/purchase/life/product/detail",
    component: _17f959b7,
    name: "purchase-life-product-detail___id"
  }, {
    path: "/purchase/motorcycle/product/detail",
    component: _6e815ec2,
    name: "purchase-motorcycle-product-detail___id"
  }, {
    path: "/purchase/smartphone/product/detail",
    component: _60ca94e4,
    name: "purchase-smartphone-product-detail___id"
  }, {
    path: "/purchase/tropical-disease/product/compare",
    component: _33a03eac,
    name: "purchase-tropical-disease-product-compare___id"
  }, {
    path: "/purchase/tropical-disease/product/detail",
    component: _3d2be880,
    name: "purchase-tropical-disease-product-detail___id"
  }, {
    path: "/th/purchase/car/addons",
    component: _c4c9a69e,
    name: "purchase-car-addons___th"
  }, {
    path: "/th/purchase/car/detail",
    component: _7625514f,
    name: "purchase-car-detail___th"
  }, {
    path: "/th/purchase/car/holder",
    component: _cba15e2c,
    name: "purchase-car-holder___th"
  }, {
    path: "/th/purchase/car/product",
    component: _0da192f2,
    name: "purchase-car-product___th"
  }, {
    path: "/th/purchase/car/quotation",
    component: _4ed178b8,
    name: "purchase-car-quotation___th"
  }, {
    path: "/th/purchase/car/summary",
    component: _f2c94f04,
    name: "purchase-car-summary___th"
  }, {
    path: "/th/purchase/hcp/holder",
    component: _32898009,
    name: "purchase-hcp-holder___th"
  }, {
    path: "/th/purchase/hcp/product",
    component: _6c1aeb48,
    name: "purchase-hcp-product___th"
  }, {
    path: "/th/purchase/hcp/summary",
    component: _0cf1e582,
    name: "purchase-hcp-summary___th"
  }, {
    path: "/th/purchase/health/declaration",
    component: _69e0baea,
    name: "purchase-health-declaration___th"
  }, {
    path: "/th/purchase/health/family",
    component: _603d94ec,
    name: "purchase-health-family___th"
  }, {
    path: "/th/purchase/health/form",
    component: _e1dd94ac,
    name: "purchase-health-form___th"
  }, {
    path: "/th/purchase/health/holder",
    component: _ab09245c,
    name: "purchase-health-holder___th"
  }, {
    path: "/th/purchase/health/member",
    component: _d6cb4d80,
    name: "purchase-health-member___th"
  }, {
    path: "/th/purchase/health/product",
    component: _1b3292c2,
    name: "purchase-health-product___th"
  }, {
    path: "/th/purchase/health/summary",
    component: _7fd2d896,
    name: "purchase-health-summary___th"
  }, {
    path: "/th/purchase/life/holder",
    component: _4d686332,
    name: "purchase-life-holder___th"
  }, {
    path: "/th/purchase/life/newPrequote",
    component: _68dea0c9,
    name: "purchase-life-newPrequote___th"
  }, {
    path: "/th/purchase/life/product",
    component: _a5cf2582,
    name: "purchase-life-product___th"
  }, {
    path: "/th/purchase/life/summary",
    component: _3a848f36,
    name: "purchase-life-summary___th"
  }, {
    path: "/th/purchase/motorcycle/detail",
    component: _6794b8bc,
    name: "purchase-motorcycle-detail___th"
  }, {
    path: "/th/purchase/motorcycle/holder",
    component: _1f80b986,
    name: "purchase-motorcycle-holder___th"
  }, {
    path: "/th/purchase/motorcycle/product",
    component: _65292e94,
    name: "purchase-motorcycle-product___th"
  }, {
    path: "/th/purchase/motorcycle/summary",
    component: _1ad55eea,
    name: "purchase-motorcycle-summary___th"
  }, {
    path: "/th/purchase/smartphone/holder",
    component: _72d28609,
    name: "purchase-smartphone-holder___th"
  }, {
    path: "/th/purchase/smartphone/product",
    component: _34f2a548,
    name: "purchase-smartphone-product___th"
  }, {
    path: "/th/purchase/smartphone/summary",
    component: _7b427182,
    name: "purchase-smartphone-summary___th"
  }, {
    path: "/th/purchase/tropical-disease/holder",
    component: _4f6c2e3b,
    name: "purchase-tropical-disease-holder___th"
  }, {
    path: "/th/purchase/tropical-disease/product",
    component: _28e3f954,
    name: "purchase-tropical-disease-product___th"
  }, {
    path: "/th/purchase/tropical-disease/summary",
    component: _78fa254d,
    name: "purchase-tropical-disease-summary___th"
  }, {
    path: "/vi/purchase/car/addons",
    component: _c4c9a69e,
    name: "purchase-car-addons___vi"
  }, {
    path: "/vi/purchase/car/detail",
    component: _7625514f,
    name: "purchase-car-detail___vi"
  }, {
    path: "/vi/purchase/car/holder",
    component: _cba15e2c,
    name: "purchase-car-holder___vi"
  }, {
    path: "/vi/purchase/car/product",
    component: _0da192f2,
    name: "purchase-car-product___vi"
  }, {
    path: "/vi/purchase/car/quotation",
    component: _4ed178b8,
    name: "purchase-car-quotation___vi"
  }, {
    path: "/vi/purchase/car/summary",
    component: _f2c94f04,
    name: "purchase-car-summary___vi"
  }, {
    path: "/vi/purchase/hcp/holder",
    component: _32898009,
    name: "purchase-hcp-holder___vi"
  }, {
    path: "/vi/purchase/hcp/product",
    component: _6c1aeb48,
    name: "purchase-hcp-product___vi"
  }, {
    path: "/vi/purchase/hcp/summary",
    component: _0cf1e582,
    name: "purchase-hcp-summary___vi"
  }, {
    path: "/vi/purchase/health/declaration",
    component: _69e0baea,
    name: "purchase-health-declaration___vi"
  }, {
    path: "/vi/purchase/health/family",
    component: _603d94ec,
    name: "purchase-health-family___vi"
  }, {
    path: "/vi/purchase/health/form",
    component: _e1dd94ac,
    name: "purchase-health-form___vi"
  }, {
    path: "/vi/purchase/health/holder",
    component: _ab09245c,
    name: "purchase-health-holder___vi"
  }, {
    path: "/vi/purchase/health/member",
    component: _d6cb4d80,
    name: "purchase-health-member___vi"
  }, {
    path: "/vi/purchase/health/product",
    component: _1b3292c2,
    name: "purchase-health-product___vi"
  }, {
    path: "/vi/purchase/health/summary",
    component: _7fd2d896,
    name: "purchase-health-summary___vi"
  }, {
    path: "/vi/purchase/life/holder",
    component: _4d686332,
    name: "purchase-life-holder___vi"
  }, {
    path: "/vi/purchase/life/newPrequote",
    component: _68dea0c9,
    name: "purchase-life-newPrequote___vi"
  }, {
    path: "/vi/purchase/life/product",
    component: _a5cf2582,
    name: "purchase-life-product___vi"
  }, {
    path: "/vi/purchase/life/summary",
    component: _3a848f36,
    name: "purchase-life-summary___vi"
  }, {
    path: "/vi/purchase/motorcycle/detail",
    component: _6794b8bc,
    name: "purchase-motorcycle-detail___vi"
  }, {
    path: "/vi/purchase/motorcycle/holder",
    component: _1f80b986,
    name: "purchase-motorcycle-holder___vi"
  }, {
    path: "/vi/purchase/motorcycle/product",
    component: _65292e94,
    name: "purchase-motorcycle-product___vi"
  }, {
    path: "/vi/purchase/motorcycle/summary",
    component: _1ad55eea,
    name: "purchase-motorcycle-summary___vi"
  }, {
    path: "/vi/purchase/smartphone/holder",
    component: _72d28609,
    name: "purchase-smartphone-holder___vi"
  }, {
    path: "/vi/purchase/smartphone/product",
    component: _34f2a548,
    name: "purchase-smartphone-product___vi"
  }, {
    path: "/vi/purchase/smartphone/summary",
    component: _7b427182,
    name: "purchase-smartphone-summary___vi"
  }, {
    path: "/vi/purchase/tropical-disease/holder",
    component: _4f6c2e3b,
    name: "purchase-tropical-disease-holder___vi"
  }, {
    path: "/vi/purchase/tropical-disease/product",
    component: _28e3f954,
    name: "purchase-tropical-disease-product___vi"
  }, {
    path: "/vi/purchase/tropical-disease/summary",
    component: _78fa254d,
    name: "purchase-tropical-disease-summary___vi"
  }, {
    path: "/en/purchase/car/product/compare",
    component: _1377b0dd,
    name: "purchase-car-product-compare___en"
  }, {
    path: "/en/purchase/car/product/detail",
    component: _2ab30f6f,
    name: "purchase-car-product-detail___en"
  }, {
    path: "/en/purchase/car/quotation/success",
    component: _e092f2d0,
    name: "purchase-car-quotation-success___en"
  }, {
    path: "/en/purchase/hcp/product/compare",
    component: _5107149e,
    name: "purchase-hcp-product-compare___en"
  }, {
    path: "/en/purchase/hcp/product/detail",
    component: _4db7af8e,
    name: "purchase-hcp-product-detail___en"
  }, {
    path: "/en/purchase/health/product/compare",
    component: _039998f5,
    name: "purchase-health-product-compare___en"
  }, {
    path: "/en/purchase/health/product/detail",
    component: _0927c457,
    name: "purchase-health-product-detail___en"
  }, {
    path: "/en/purchase/life/product/compare",
    component: _620aa0d6,
    name: "purchase-life-product-compare___en"
  }, {
    path: "/en/purchase/life/product/detail",
    component: _17f959b7,
    name: "purchase-life-product-detail___en"
  }, {
    path: "/en/purchase/motorcycle/product/detail",
    component: _6e815ec2,
    name: "purchase-motorcycle-product-detail___en"
  }, {
    path: "/en/purchase/smartphone/product/detail",
    component: _60ca94e4,
    name: "purchase-smartphone-product-detail___en"
  }, {
    path: "/en/purchase/tropical-disease/product/compare",
    component: _33a03eac,
    name: "purchase-tropical-disease-product-compare___en"
  }, {
    path: "/en/purchase/tropical-disease/product/detail",
    component: _3d2be880,
    name: "purchase-tropical-disease-product-detail___en"
  }, {
    path: "/ms/purchase/car/product/compare",
    component: _1377b0dd,
    name: "purchase-car-product-compare___ms"
  }, {
    path: "/ms/purchase/car/product/detail",
    component: _2ab30f6f,
    name: "purchase-car-product-detail___ms"
  }, {
    path: "/ms/purchase/car/quotation/success",
    component: _e092f2d0,
    name: "purchase-car-quotation-success___ms"
  }, {
    path: "/ms/purchase/hcp/product/compare",
    component: _5107149e,
    name: "purchase-hcp-product-compare___ms"
  }, {
    path: "/ms/purchase/hcp/product/detail",
    component: _4db7af8e,
    name: "purchase-hcp-product-detail___ms"
  }, {
    path: "/ms/purchase/health/product/compare",
    component: _039998f5,
    name: "purchase-health-product-compare___ms"
  }, {
    path: "/ms/purchase/health/product/detail",
    component: _0927c457,
    name: "purchase-health-product-detail___ms"
  }, {
    path: "/ms/purchase/life/product/compare",
    component: _620aa0d6,
    name: "purchase-life-product-compare___ms"
  }, {
    path: "/ms/purchase/life/product/detail",
    component: _17f959b7,
    name: "purchase-life-product-detail___ms"
  }, {
    path: "/ms/purchase/motorcycle/product/detail",
    component: _6e815ec2,
    name: "purchase-motorcycle-product-detail___ms"
  }, {
    path: "/ms/purchase/smartphone/product/detail",
    component: _60ca94e4,
    name: "purchase-smartphone-product-detail___ms"
  }, {
    path: "/ms/purchase/tropical-disease/product/compare",
    component: _33a03eac,
    name: "purchase-tropical-disease-product-compare___ms"
  }, {
    path: "/ms/purchase/tropical-disease/product/detail",
    component: _3d2be880,
    name: "purchase-tropical-disease-product-detail___ms"
  }, {
    path: "/th/purchase/car/product/compare",
    component: _1377b0dd,
    name: "purchase-car-product-compare___th"
  }, {
    path: "/th/purchase/car/product/detail",
    component: _2ab30f6f,
    name: "purchase-car-product-detail___th"
  }, {
    path: "/th/purchase/car/quotation/success",
    component: _e092f2d0,
    name: "purchase-car-quotation-success___th"
  }, {
    path: "/th/purchase/hcp/product/compare",
    component: _5107149e,
    name: "purchase-hcp-product-compare___th"
  }, {
    path: "/th/purchase/hcp/product/detail",
    component: _4db7af8e,
    name: "purchase-hcp-product-detail___th"
  }, {
    path: "/th/purchase/health/product/compare",
    component: _039998f5,
    name: "purchase-health-product-compare___th"
  }, {
    path: "/th/purchase/health/product/detail",
    component: _0927c457,
    name: "purchase-health-product-detail___th"
  }, {
    path: "/th/purchase/life/product/compare",
    component: _620aa0d6,
    name: "purchase-life-product-compare___th"
  }, {
    path: "/th/purchase/life/product/detail",
    component: _17f959b7,
    name: "purchase-life-product-detail___th"
  }, {
    path: "/th/purchase/motorcycle/product/detail",
    component: _6e815ec2,
    name: "purchase-motorcycle-product-detail___th"
  }, {
    path: "/th/purchase/smartphone/product/detail",
    component: _60ca94e4,
    name: "purchase-smartphone-product-detail___th"
  }, {
    path: "/th/purchase/tropical-disease/product/compare",
    component: _33a03eac,
    name: "purchase-tropical-disease-product-compare___th"
  }, {
    path: "/th/purchase/tropical-disease/product/detail",
    component: _3d2be880,
    name: "purchase-tropical-disease-product-detail___th"
  }, {
    path: "/vi/purchase/car/product/compare",
    component: _1377b0dd,
    name: "purchase-car-product-compare___vi"
  }, {
    path: "/vi/purchase/car/product/detail",
    component: _2ab30f6f,
    name: "purchase-car-product-detail___vi"
  }, {
    path: "/vi/purchase/car/quotation/success",
    component: _e092f2d0,
    name: "purchase-car-quotation-success___vi"
  }, {
    path: "/vi/purchase/hcp/product/compare",
    component: _5107149e,
    name: "purchase-hcp-product-compare___vi"
  }, {
    path: "/vi/purchase/hcp/product/detail",
    component: _4db7af8e,
    name: "purchase-hcp-product-detail___vi"
  }, {
    path: "/vi/purchase/health/product/compare",
    component: _039998f5,
    name: "purchase-health-product-compare___vi"
  }, {
    path: "/vi/purchase/health/product/detail",
    component: _0927c457,
    name: "purchase-health-product-detail___vi"
  }, {
    path: "/vi/purchase/life/product/compare",
    component: _620aa0d6,
    name: "purchase-life-product-compare___vi"
  }, {
    path: "/vi/purchase/life/product/detail",
    component: _17f959b7,
    name: "purchase-life-product-detail___vi"
  }, {
    path: "/vi/purchase/motorcycle/product/detail",
    component: _6e815ec2,
    name: "purchase-motorcycle-product-detail___vi"
  }, {
    path: "/vi/purchase/smartphone/product/detail",
    component: _60ca94e4,
    name: "purchase-smartphone-product-detail___vi"
  }, {
    path: "/vi/purchase/tropical-disease/product/compare",
    component: _33a03eac,
    name: "purchase-tropical-disease-product-compare___vi"
  }, {
    path: "/vi/purchase/tropical-disease/product/detail",
    component: _3d2be880,
    name: "purchase-tropical-disease-product-detail___vi"
  }, {
    path: "/en/purchase/car/product/detail/:sharedId",
    component: _e162de42,
    name: "purchase-car-product-detail-sharedId___en"
  }, {
    path: "/en/purchase/hcp/product/detail/:sharedId",
    component: _96865384,
    name: "purchase-hcp-product-detail-sharedId___en"
  }, {
    path: "/en/purchase/health/product/detail/:sharedId",
    component: _ac977872,
    name: "purchase-health-product-detail-sharedId___en"
  }, {
    path: "/en/purchase/life/product/detail/:sharedId",
    component: _1912a127,
    name: "purchase-life-product-detail-sharedId___en"
  }, {
    path: "/en/purchase/motorcycle/product/detail/:sharedId",
    component: _7a27d71c,
    name: "purchase-motorcycle-product-detail-sharedId___en"
  }, {
    path: "/en/purchase/smartphone/product/detail/:sharedId",
    component: _59df4784,
    name: "purchase-smartphone-product-detail-sharedId___en"
  }, {
    path: "/en/purchase/tropical-disease/product/detail/:sharedId",
    component: _16d71bf0,
    name: "purchase-tropical-disease-product-detail-sharedId___en"
  }, {
    path: "/ms/purchase/car/product/detail/:sharedId",
    component: _e162de42,
    name: "purchase-car-product-detail-sharedId___ms"
  }, {
    path: "/ms/purchase/hcp/product/detail/:sharedId",
    component: _96865384,
    name: "purchase-hcp-product-detail-sharedId___ms"
  }, {
    path: "/ms/purchase/health/product/detail/:sharedId",
    component: _ac977872,
    name: "purchase-health-product-detail-sharedId___ms"
  }, {
    path: "/ms/purchase/life/product/detail/:sharedId",
    component: _1912a127,
    name: "purchase-life-product-detail-sharedId___ms"
  }, {
    path: "/ms/purchase/motorcycle/product/detail/:sharedId",
    component: _7a27d71c,
    name: "purchase-motorcycle-product-detail-sharedId___ms"
  }, {
    path: "/ms/purchase/smartphone/product/detail/:sharedId",
    component: _59df4784,
    name: "purchase-smartphone-product-detail-sharedId___ms"
  }, {
    path: "/ms/purchase/tropical-disease/product/detail/:sharedId",
    component: _16d71bf0,
    name: "purchase-tropical-disease-product-detail-sharedId___ms"
  }, {
    path: "/th/purchase/car/product/detail/:sharedId",
    component: _e162de42,
    name: "purchase-car-product-detail-sharedId___th"
  }, {
    path: "/th/purchase/hcp/product/detail/:sharedId",
    component: _96865384,
    name: "purchase-hcp-product-detail-sharedId___th"
  }, {
    path: "/th/purchase/health/product/detail/:sharedId",
    component: _ac977872,
    name: "purchase-health-product-detail-sharedId___th"
  }, {
    path: "/th/purchase/life/product/detail/:sharedId",
    component: _1912a127,
    name: "purchase-life-product-detail-sharedId___th"
  }, {
    path: "/th/purchase/motorcycle/product/detail/:sharedId",
    component: _7a27d71c,
    name: "purchase-motorcycle-product-detail-sharedId___th"
  }, {
    path: "/th/purchase/smartphone/product/detail/:sharedId",
    component: _59df4784,
    name: "purchase-smartphone-product-detail-sharedId___th"
  }, {
    path: "/th/purchase/tropical-disease/product/detail/:sharedId",
    component: _16d71bf0,
    name: "purchase-tropical-disease-product-detail-sharedId___th"
  }, {
    path: "/vi/purchase/car/product/detail/:sharedId",
    component: _e162de42,
    name: "purchase-car-product-detail-sharedId___vi"
  }, {
    path: "/vi/purchase/hcp/product/detail/:sharedId",
    component: _96865384,
    name: "purchase-hcp-product-detail-sharedId___vi"
  }, {
    path: "/vi/purchase/health/product/detail/:sharedId",
    component: _ac977872,
    name: "purchase-health-product-detail-sharedId___vi"
  }, {
    path: "/vi/purchase/life/product/detail/:sharedId",
    component: _1912a127,
    name: "purchase-life-product-detail-sharedId___vi"
  }, {
    path: "/vi/purchase/motorcycle/product/detail/:sharedId",
    component: _7a27d71c,
    name: "purchase-motorcycle-product-detail-sharedId___vi"
  }, {
    path: "/vi/purchase/smartphone/product/detail/:sharedId",
    component: _59df4784,
    name: "purchase-smartphone-product-detail-sharedId___vi"
  }, {
    path: "/vi/purchase/tropical-disease/product/detail/:sharedId",
    component: _16d71bf0,
    name: "purchase-tropical-disease-product-detail-sharedId___vi"
  }, {
    path: "/en/purchase/car/detail/:transactionNumber",
    component: _7dd3b144,
    name: "purchase-car-detail-transactionNumber___en"
  }, {
    path: "/en/purchase/car/holder/:transactionNumber",
    component: _19f293e3,
    name: "purchase-car-holder-transactionNumber___en"
  }, {
    path: "/en/purchase/health/family/:transactionNumber",
    component: _3697a97a,
    name: "purchase-health-family-transactionNumber___en"
  }, {
    path: "/en/purchase/health/holder/:transactionNumber",
    component: _4c433dfb,
    name: "purchase-health-holder-transactionNumber___en"
  }, {
    path: "/en/purchase/motorcycle/detail/:transactionNumber",
    component: _0129162b,
    name: "purchase-motorcycle-detail-transactionNumber___en"
  }, {
    path: "/en/purchase/motorcycle/holder/:transactionNumber",
    component: _5a0582b0,
    name: "purchase-motorcycle-holder-transactionNumber___en"
  }, {
    path: "/ms/purchase/car/detail/:transactionNumber",
    component: _7dd3b144,
    name: "purchase-car-detail-transactionNumber___ms"
  }, {
    path: "/ms/purchase/car/holder/:transactionNumber",
    component: _19f293e3,
    name: "purchase-car-holder-transactionNumber___ms"
  }, {
    path: "/ms/purchase/health/family/:transactionNumber",
    component: _3697a97a,
    name: "purchase-health-family-transactionNumber___ms"
  }, {
    path: "/ms/purchase/health/holder/:transactionNumber",
    component: _4c433dfb,
    name: "purchase-health-holder-transactionNumber___ms"
  }, {
    path: "/ms/purchase/motorcycle/detail/:transactionNumber",
    component: _0129162b,
    name: "purchase-motorcycle-detail-transactionNumber___ms"
  }, {
    path: "/ms/purchase/motorcycle/holder/:transactionNumber",
    component: _5a0582b0,
    name: "purchase-motorcycle-holder-transactionNumber___ms"
  }, {
    path: "/purchase/car/product/detail/:sharedId",
    component: _e162de42,
    name: "purchase-car-product-detail-sharedId___id"
  }, {
    path: "/purchase/hcp/product/detail/:sharedId",
    component: _96865384,
    name: "purchase-hcp-product-detail-sharedId___id"
  }, {
    path: "/purchase/health/product/detail/:sharedId",
    component: _ac977872,
    name: "purchase-health-product-detail-sharedId___id"
  }, {
    path: "/purchase/life/product/detail/:sharedId",
    component: _1912a127,
    name: "purchase-life-product-detail-sharedId___id"
  }, {
    path: "/purchase/motorcycle/product/detail/:sharedId",
    component: _7a27d71c,
    name: "purchase-motorcycle-product-detail-sharedId___id"
  }, {
    path: "/purchase/smartphone/product/detail/:sharedId",
    component: _59df4784,
    name: "purchase-smartphone-product-detail-sharedId___id"
  }, {
    path: "/purchase/tropical-disease/product/detail/:sharedId",
    component: _16d71bf0,
    name: "purchase-tropical-disease-product-detail-sharedId___id"
  }, {
    path: "/th/purchase/car/detail/:transactionNumber",
    component: _7dd3b144,
    name: "purchase-car-detail-transactionNumber___th"
  }, {
    path: "/th/purchase/car/holder/:transactionNumber",
    component: _19f293e3,
    name: "purchase-car-holder-transactionNumber___th"
  }, {
    path: "/th/purchase/health/family/:transactionNumber",
    component: _3697a97a,
    name: "purchase-health-family-transactionNumber___th"
  }, {
    path: "/th/purchase/health/holder/:transactionNumber",
    component: _4c433dfb,
    name: "purchase-health-holder-transactionNumber___th"
  }, {
    path: "/th/purchase/motorcycle/detail/:transactionNumber",
    component: _0129162b,
    name: "purchase-motorcycle-detail-transactionNumber___th"
  }, {
    path: "/th/purchase/motorcycle/holder/:transactionNumber",
    component: _5a0582b0,
    name: "purchase-motorcycle-holder-transactionNumber___th"
  }, {
    path: "/vi/purchase/car/detail/:transactionNumber",
    component: _7dd3b144,
    name: "purchase-car-detail-transactionNumber___vi"
  }, {
    path: "/vi/purchase/car/holder/:transactionNumber",
    component: _19f293e3,
    name: "purchase-car-holder-transactionNumber___vi"
  }, {
    path: "/vi/purchase/health/family/:transactionNumber",
    component: _3697a97a,
    name: "purchase-health-family-transactionNumber___vi"
  }, {
    path: "/vi/purchase/health/holder/:transactionNumber",
    component: _4c433dfb,
    name: "purchase-health-holder-transactionNumber___vi"
  }, {
    path: "/vi/purchase/motorcycle/detail/:transactionNumber",
    component: _0129162b,
    name: "purchase-motorcycle-detail-transactionNumber___vi"
  }, {
    path: "/vi/purchase/motorcycle/holder/:transactionNumber",
    component: _5a0582b0,
    name: "purchase-motorcycle-holder-transactionNumber___vi"
  }, {
    path: "/en/policy/add/:partner",
    component: _635fdb09,
    name: "policy-add-partner___en"
  }, {
    path: "/en/promo/detail/:promoCode",
    component: _4bdc63f0,
    name: "promo-detail-promoCode___en"
  }, {
    path: "/ms/policy/add/:partner",
    component: _635fdb09,
    name: "policy-add-partner___ms"
  }, {
    path: "/ms/promo/detail/:promoCode",
    component: _4bdc63f0,
    name: "promo-detail-promoCode___ms"
  }, {
    path: "/purchase/car/detail/:transactionNumber",
    component: _7dd3b144,
    name: "purchase-car-detail-transactionNumber___id"
  }, {
    path: "/purchase/car/holder/:transactionNumber",
    component: _19f293e3,
    name: "purchase-car-holder-transactionNumber___id"
  }, {
    path: "/purchase/health/family/:transactionNumber",
    component: _3697a97a,
    name: "purchase-health-family-transactionNumber___id"
  }, {
    path: "/purchase/health/holder/:transactionNumber",
    component: _4c433dfb,
    name: "purchase-health-holder-transactionNumber___id"
  }, {
    path: "/purchase/motorcycle/detail/:transactionNumber",
    component: _0129162b,
    name: "purchase-motorcycle-detail-transactionNumber___id"
  }, {
    path: "/purchase/motorcycle/holder/:transactionNumber",
    component: _5a0582b0,
    name: "purchase-motorcycle-holder-transactionNumber___id"
  }, {
    path: "/th/policy/add/:partner",
    component: _635fdb09,
    name: "policy-add-partner___th"
  }, {
    path: "/th/promo/detail/:promoCode",
    component: _4bdc63f0,
    name: "promo-detail-promoCode___th"
  }, {
    path: "/vi/policy/add/:partner",
    component: _635fdb09,
    name: "policy-add-partner___vi"
  }, {
    path: "/vi/promo/detail/:promoCode",
    component: _4bdc63f0,
    name: "promo-detail-promoCode___vi"
  }, {
    path: "/en/blogs/:slug",
    component: _dae915be,
    name: "blogs-slug___en"
  }, {
    path: "/en/claim/:product",
    component: _91578578,
    name: "claim-product___en"
  }, {
    path: "/en/payment/:result",
    component: _1d485488,
    name: "payment-result___en"
  }, {
    path: "/en/request/:product",
    component: _3d84da91,
    name: "request-product___en"
  }, {
    path: "/ms/blogs/:slug",
    component: _dae915be,
    name: "blogs-slug___ms"
  }, {
    path: "/ms/claim/:product",
    component: _91578578,
    name: "claim-product___ms"
  }, {
    path: "/ms/payment/:result",
    component: _1d485488,
    name: "payment-result___ms"
  }, {
    path: "/ms/request/:product",
    component: _3d84da91,
    name: "request-product___ms"
  }, {
    path: "/policy/add/:partner",
    component: _635fdb09,
    name: "policy-add-partner___id"
  }, {
    path: "/promo/detail/:promoCode",
    component: _4bdc63f0,
    name: "promo-detail-promoCode___id"
  }, {
    path: "/th/blogs/:slug",
    component: _dae915be,
    name: "blogs-slug___th"
  }, {
    path: "/th/claim/:product",
    component: _91578578,
    name: "claim-product___th"
  }, {
    path: "/th/payment/:result",
    component: _1d485488,
    name: "payment-result___th"
  }, {
    path: "/th/request/:product",
    component: _3d84da91,
    name: "request-product___th"
  }, {
    path: "/vi/blogs/:slug",
    component: _dae915be,
    name: "blogs-slug___vi"
  }, {
    path: "/vi/claim/:product",
    component: _91578578,
    name: "claim-product___vi"
  }, {
    path: "/vi/payment/:result",
    component: _1d485488,
    name: "payment-result___vi"
  }, {
    path: "/vi/request/:product",
    component: _3d84da91,
    name: "request-product___vi"
  }, {
    path: "/blogs/:slug",
    component: _dae915be,
    name: "blogs-slug___id"
  }, {
    path: "/claim/:product",
    component: _91578578,
    name: "claim-product___id"
  }, {
    path: "/payment/:result",
    component: _1d485488,
    name: "payment-result___id"
  }, {
    path: "/request/:product",
    component: _3d84da91,
    name: "request-product___id"
  }, {
    path: "/",
    component: _d9144d38,
    name: "index___id"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
